/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import SVGComponent from '../../../components/SVG/SVGComponent';
import { GOLDEN_GOAL_SETTINGS_INPUTS, SVG_ICONS } from '../../../constants';

const GoldenGoalSettingsRow = ({
  rowBeingEditted, settings, getLeagueName, idx, updateInputs,
  hasPermissionToUpdate, updateSelectedRow, saveChanges, cancelChanges,
  errors,
}) => {
  const maximumProbabilityError = errors?.[`maximumProbability-${idx}`];
  const winningProbabilityCoefficientError = errors?.[`winningProbabilityCoefficient-${idx}`];

  return (

    <tr
      className={`table-style__row 
        ${rowBeingEditted === settings?.competitionId ? 'edit-row' : ''}`}
      disabled={rowBeingEditted !== null
                  && rowBeingEditted !== settings?.competitionId}
    >
      <td>{getLeagueName(settings?.competitionId)}</td>
      <td>
        <div className="d-flex align-items-center justify-content-center">
          <span>0 &lt;</span>
          <div>
            <div className="input-value mx-3">{Number(settings?.config?.maxProbability)?.toFixed(2)}</div>
            <input
              className={`table-style__row-input table-style__row-input--hidden mx-3 text-center
                ${maximumProbabilityError ? 'table-style__row-input--error' : ''} 
            `}
              value={Number(settings?.config?.maxProbability)?.toFixed(2)}
              name={`maximumProbability-${idx}`}
              type="number"
              step="0.01"
              min="0"
              max="1"
              onChange={(e) => updateInputs(e.target.value, GOLDEN_GOAL_SETTINGS_INPUTS.MAX_PROB)}
            />
          </div>
          <span>&lt; 1</span>
        </div>

        {maximumProbabilityError && (<div>{maximumProbabilityError}</div>)}

      </td>

      <td>
        <div className="d-flex align-items-center justify-content-center">
          <span>0 &lt;</span>
          <div>
            <div className="input-value mx-3">{Number(settings?.config?.winningProbabilityCoefficient)?.toFixed(2)}</div>
            <input
              className={`table-style__row-input table-style__row-input--hidden mx-3 text-center
                ${winningProbabilityCoefficientError ? 'table-style__row-input--error' : ''}
              `}
              value={Number(settings?.config?.winningProbabilityCoefficient)?.toFixed(2)}
              type="number"
              step="0.01"
              min="0"
              max="1"
              onChange={(e) => updateInputs(e.target.value, GOLDEN_GOAL_SETTINGS_INPUTS.WINN_COEFF)}
            />
          </div>
          <span>&lt; 1</span>
        </div>
        {winningProbabilityCoefficientError && (<div>{winningProbabilityCoefficientError}</div>)}

      </td>

      {hasPermissionToUpdate && (
        <td>
          <div className="d-flex justify-content-center">
            <div
              className="option-btn"
              onClick={updateSelectedRow.bind(this, settings?.competitionId)}
            >
              <span>Change Settings</span>
            </div>
            <div className="action">
              <div className="action-wrap">
                <div
                  className="action__btn action__btn--approve"
                  onClick={saveChanges}
                >
                  <SVGComponent src={`${SVG_ICONS.utility}#tick1`} />
                </div>
                <div
                  className="action__btn action__btn--cancel"
                  onClick={cancelChanges}
                >
                  <SVGComponent src={`${SVG_ICONS.utility}#close-w`} />
                </div>
              </div>
            </div>
          </div>
        </td>
      )}

    </tr>
  );
};

export default GoldenGoalSettingsRow;
